import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowFatLinesUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m2 7.5 6-6 6 6h-3v2H5v-2H2ZM11 13.5H5M11 11.5H5"
	})
});
export default SvgArrowFatLinesUp;
